import React from "react"
import { Helmet } from "react-helmet"
import styled, { injectGlobal } from "styled-components"
import * as PropTypes from "prop-types"

import media from "../utils/media"

import favicon from "./../images/favicon.ico"
import shareImg from "./../images/meta-reductionism.jpg"

import lrWebDemi from "./../fonts/lr-web-demi.woff"
import avenirBlack from "./../fonts/avenir-black.woff"
import avenirRoman from "./../fonts/avenir-roman.woff"

const propTypes = {
  children: PropTypes.func.isRequired
}

class DefaultLayout extends React.Component {
  render() {
    let robots = null
    if (process.env.GATSBY_PREVIEW == "true") {
      robots = <meta name="robots" content="noindex, nofollow" />
    }

    return (
      <div>
        <Helmet>
          <link rel="icon" href={favicon} />
          <title>What is Reductionism? - The New Range Rover Velar</title>
          <meta name="title" content="What is Reductionism?" />
          <meta
            name="description"
            content="Inspired by the New Range Rover Velar, we dig in to the less-is-more philosophy"
          />

          {robots}

          <meta property="og:title" content="What is Reductionism?" />
          <meta property="og:type" content="article" />
          <meta property="og:image" content={shareImg} />
          <meta
            property="og:description"
            content="Inspired by the New Range Rover Velar, we dig in to the less-is-more philosophy"
          />
          <meta property="og:url" content="http://www.reductionism.is" />
          <meta property="og:site_name" content="Cool Hunting" />
          <meta property="fb:admins" content="22701891" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:url" content="http://www.reductionism.is" />
          <meta name="twitter:title" content="What is Reductionism?" />
          <meta
            name="twitter:description"
            content="Lessons on reducing excessive design, from Gerry McGovern, Chief Design Officer, @LandRoverUSA &#23;sponsored"
          />
          <meta name="twitter:image" content={shareImg} />
          <meta name="twitter:site" content="@coolhunting" />
        </Helmet>
        {this.props.children()}
      </div>
    )
  }
}

DefaultLayout.propTypes = propTypes

export default DefaultLayout

injectGlobal`
  html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{-moz-box-sizing:content-box;box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;-moz-box-sizing:content-box;-webkit-box-sizing:content-box;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}

  *, *:before, *:after {
      box-sizing: border-box;
      -webkit-overflow-scrolling: touch;
  }

  @font-face {
    font-family: 'LRWebDemi';
    src: url(${lrWebDemi}) format('woff');
  }

  @font-face {
    font-family: 'AvenirBlack';
    src: url(${avenirBlack}) format('woff');
  }

  @font-face {
    font-family: 'AvenirRoman';
    src: url(${avenirRoman}) format('woff');
  }

  html {
    font-size: 100%;
  }

  body {
    font-size: .84rem;
    line-height: 1.6;
    font-weight: 400;
    font-family: 'AvenirRoman', sans-serif;
    color: #0C121C;

    webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  a {
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 0.1rem;
    color: inherit;
    &:hover,
    &:active {
      color: inherit;
    }
  }

  h1, h2, h3 {
    margin: 0;
    font-weight: 300;
    font-family: 'LRWebDemi', sans-serif;
    text-transform: uppercase;
  }

  h1 { 
    font-size: 2.0125rem; 
    line-height: 1.1; 
    letter-spacing: .1rem;
    ${media.tablet`
      font-size: 2.3125rem;
    `}
  }
  
  h2 { 
    font-size: 1.4375rem; 
    line-height: 1.2; 
    letter-spacing: .1rem;
  }

  p {
    margin: 0 0 1rem;
    a {
      font-family: "AvenirBlack";
      &:hover {
        opacity: 0.75;
      }
    }
  }
  
  img {
    display: block;
    height: auto;
    width: 100%;
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js